import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import productCacheAdminService from '../services/productCacheAdminService';

export const useProductCacheList = (pageNumber: number, pageSize: number, retailer?: string, searchTerm?: string) => {
  return useQuery({
    queryKey: ['productCache', 'list', pageNumber, pageSize, retailer, searchTerm],
    queryFn: () => productCacheAdminService.getAll(pageNumber, pageSize, retailer, searchTerm),
  });
};

export const useProductCacheDetail = (productId: string, retailer: string, enabled = false) => {
  return useQuery({
    queryKey: ['productCache', 'detail', productId, retailer],
    queryFn: () => productCacheAdminService.getById(productId, retailer),
    enabled: enabled && !!productId && !!retailer,
  });
};

export const useProductCacheStats = () => {
  return useQuery({
    queryKey: ['productCache', 'stats'],
    queryFn: () => productCacheAdminService.getStats(),
  });
};

export const useProductCacheMutations = () => {
  const queryClient = useQueryClient();

  const deleteProduct = useMutation({
    mutationFn: ({ productId, retailer }: { productId: string; retailer: string }) =>
      productCacheAdminService.delete(productId, retailer),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productCache'] });
      console.log('Product deleted from cache successfully');
    },
    onError: (error: any) => {
      console.error('Failed to delete product:', error?.response?.data?.message || error.message);
    },
  });

  return { deleteProduct };
};

